export default function Validation(formData) {
  const errors = {};
  const email_pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const mobile_pattern = /^\d{10}$/;
  if (formData.fName === "") {
    errors.fName = "First Name is required";
    }
    if (formData.lName === "") {
      errors.lName = "Last Name is required";
    }
  if (formData.email === "") {
    errors.email = "Email is required";
  } else if (!email_pattern.test(formData.email)) {
    errors.email = "Email didn't match";
  }
  if (formData.mobile === "") {
    errors.mobile = "Mobile number is required";
  } else if (!mobile_pattern.test(formData.mobile)) {
    errors.mobile = "Mobile number didn't match";
  }
 
  return errors;
}
